(() => {
  if (customElements.get('landing-society')) return;

  class LandingSociety extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onVideoEnded = this.onVideoEnded.bind(this);
      this.onVideoPause = this.onVideoPause.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.currentVideo = null;
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);

      this.querySelectorAll('[data-js-video]').forEach((video) => {
        video.addEventListener('ended', this.onVideoEnded);
        video.addEventListener('pause', this.onVideoPause);
      });

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);

      this.querySelectorAll('[data-js-video]').forEach((video) => {
        video.removeEventListener('ended', this.onVideoEnded);
        video.removeEventListener('pause', this.onVideoPause);
      });

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }

      this.currentVideo = null;
    }

    onSectionLoad(event) {
      if (!event.target.contains(this)) return;
      this.resetAllVideos();
    }

    onClick(event) {
      const playTrigger = event.target.closest('[data-js-play-trigger]');
      const cardMedia = event.target.closest('[data-js-card-media]');

      if (playTrigger) {
        event.preventDefault();
        this.playVideo(cardMedia);
        return;
      }

      if (!cardMedia) return;

      const video = cardMedia.querySelector('[data-js-video]');
      if (!video || video.paused) return;

      video.pause();
    }

    setCardPlaying(cardMedia, isPlaying) {
      if (!cardMedia) return;

      const poster = cardMedia.querySelector('[data-js-poster]');
      const content = cardMedia.querySelector('[data-js-card-content]');

      if (poster) {
        poster.classList.toggle('is-hidden', isPlaying);
      }

      if (content) {
        content.classList.toggle('is-hidden', isPlaying);
      }
    }

    playVideo(cardMedia) {
      if (!cardMedia) return;

      const video = cardMedia.querySelector('[data-js-video]');

      if (!video) return;

      if (this.currentVideo && this.currentVideo !== video) {
        this.resetVideo(this.currentVideo);
      }

      this.setCardPlaying(cardMedia, true);

      video.muted = false;
      video.play();
      this.currentVideo = video;
    }

    resetVideo(video) {
      if (!video) return;

      const cardMedia = video.closest('[data-js-card-media]');

      video.pause();
      video.currentTime = 0;
      video.muted = true;

      this.setCardPlaying(cardMedia, false);
    }

    resetAllVideos() {
      this.querySelectorAll('[data-js-video]').forEach((video) => {
        this.resetVideo(video);
      });
      this.currentVideo = null;
    }

    onVideoEnded(event) {
      this.resetVideo(event.currentTarget);

      if (this.currentVideo === event.currentTarget) {
        this.currentVideo = null;
      }
    }

    onVideoPause(event) {
      const video = event.currentTarget;

      if (video.ended) return;

      const cardMedia = video.closest('[data-js-card-media]');
      this.setCardPlaying(cardMedia, false);

      if (this.currentVideo === video) {
        this.currentVideo = null;
      }
    }
  }

  customElements.define('landing-society', LandingSociety);
})();
